import React from 'react';
import './HrMission.css';

function HrMission(): JSX.Element {
  return (
    <div className="hr-mission">
      <div className="line">Собираем команду суперменов и супергёрлc</div>
      <br />
      <div className="line">из мира IT и образования</div>
    </div>
  );
}

export default HrMission;
